<template>
    <div class="newPage">
        <div class="content">

            <div class="HistoryList">
                <el-table
                        :data="historyList.list"
                        stripe
                >
                    <el-table-column
                            label="序号"
                            align="center"
                            type="index"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="模板名称"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.wordGenerate ? scope.row.wordGenerate.name :''}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="所属城市"
                    >
                        <template slot-scope="scope">
                            {{scope.row.city}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="createTime" align="center"
                            label="时间">
                        <template slot-scope="scope">
                            <div>{{scope.row.createTime | YearDate}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="330"
                            prop="address" align="center"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="jump(scope.row)">查看/修改</el-button>
                            <el-button size="mini" @click="implement(scope.row)">查看执行记录</el-button>
                            <el-button size="mini" @click="deleteItem(scope.row)">删除</el-button>
                            <!--<el-button size="mini" @click="download(scope.row,1)">下载 word</el-button>-->
                            <!--<el-button size="mini" @click="download(scope.row,2)">下载 pdf</el-button>-->
                        </template>
                    </el-table-column>
                </el-table>
                <pagination
                        v-show="historyList.totalCount>0"
                        :total="historyList.totalCount"
                        :page.sync="params.page"
                        :limit.sync="params.pageSize"
                        @pagination="getWordTemplategenerateList"
                />
            </div>
        </div>

        <el-dialog title="定时任务" :visible.sync="open" width="80%" append-to-body>
            <el-form ref="form" :model="form" size="mini" :rules="rules" label-width="140px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="时间" prop="time">
                            <el-time-picker
                                    size="mini"
                                    value-format="HH:mm:ss"
                                    v-model="form.time"
                                    placeholder="任意时间点">
                            </el-time-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="基准值" prop="baseTime">
                            <el-input-number
                                    size="mini"
                                    v-model="form.baseTime"
                                    label="基准值"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="cron表达式" prop="cron">
                            <el-input
                                    size="mini"
                                    v-model="form.cron"
                                    placeholder="cron表达式"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="城市" prop="city">
                            <el-cascader
                                    v-model="form.city"
                                    :options="cityList"
                                    :props="cityProps"
                                    clearable
                                    size="mini"
                            ></el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="状态" prop="status">
                            <el-switch
                                    v-model="form.status"
                                    :active-value="1"
                                    :inactive-value="-1">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="submitForm">修 改</el-button>
                <el-button size="mini" @click="cancel">取 消</el-button>
            </div>
        </el-dialog>


        <el-dialog title="定时任务" :visible.sync="ChartOpen" width="80%" append-to-body>
            <el-form ref="form" :model="form" size="mini" :rules="rules" label-width="140px">
                <el-row>

                    <el-col :span="24">
                        <el-form-item label="基准值" prop="baseTime">
                            <el-input-number
                                    size="mini"
                                    v-model="form.baseTime"
                                    label="基准值"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="cron表达式" prop="cron">
                            <el-input
                                    size="mini"
                                    v-model="form.cron"
                                    placeholder="cron表达式"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="状态" prop="status">
                            <el-switch
                                    v-model="form.status"
                                    :active-value="1"
                                    :inactive-value="-1">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="ChartSubmitForm">修 改</el-button>
                <el-button size="mini" @click="cancel">取 消</el-button>
            </div>
        </el-dialog>


        <el-dialog title="定时任务执行记录" :visible.sync="implementOpen" width="80%" append-to-body>
            <!--<div class="implementList">-->
                <!--<div class="implementItem" v-for="(item,index) in implementResult.list" :key="index">-->
                    <!--<div class="implementTime">-->
                        <!--执行时间: {{item.taskTime}}-->
                    <!--</div>-->
                    <!--<div class="implementContent">-->
                        <!--执行结果: {{item.resultContent}}-->
                    <!--</div>-->
                    <!--<div class="implementResult">-->
                        <!--<el-tag v-if="item.result===0">成功</el-tag>-->
                        <!--<el-tag v-else type="danger">失败</el-tag>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->

            <el-table
                    :data="implementResult.list"
                    style="width: 100%">
                <el-table-column
                        prop="taskTime"
                        label="执行时间"
                        >
                </el-table-column>
                <el-table-column
                        :show-overflow-tooltip="true"
                        prop="resultContent"
                        label="执行结果"
                       >
                </el-table-column>
                <el-table-column
                        prop="result"
                        label="执行状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.result===0">成功</el-tag>
                        <el-tag v-else type="danger">失败</el-tag>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                    v-show="implementResult.totalCount>0"
                    :total="implementResult.totalCount"
                    :page.sync="implementParams.page"
                    :limit.sync="implementParams.pageSize"
                    @pagination="implement({id:implementParams.id})"
            />
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="cancel">取 消</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>

    import url from "../../../utils/UrlApi"

    function params(obj) {
        let result = '';
        let item;
        for (item in obj) {
            if (obj[item] && String(obj[item])) {
                result += `&${item}=${obj[item]}`;
            }
        }
        if (result) {
            result = '?' + result.slice(1);
        }
        return result;
    }

    export default {
        name: "VOCHistory",
        components: {},
        data() {
            return {
                historyList: {
                    currPage: 1,
                    list: [],
                    pageSize: 0,
                    totalCount: 0,
                    totalPage: 0,
                },
                params: {
                    page: 1,
                    pageSize: 10,
                },
                open: false,
                ChartOpen: false,
                form: {},
                rules: {
                    time: [
                        {required: true, message: "时间不能为空", trigger: "blur"}
                    ],
                    baseTime: [
                        {required: true, message: "基准值不能为空", trigger: "blur"}
                    ],
                    cron: [
                        {required: true, message: "cron表达式不能为空", trigger: "blur"}
                    ],
                    city: [
                        {required: true, message: "城市不能为空", trigger: "blur"}
                    ],
                    status: [
                        {required: true, message: "状态不能为空", trigger: "blur"}
                    ],
                },
                cityList: [],
                cityProps: {
                    multiple: false,
                    emitPath: true,
                    label: "lable",
                    value: "lable"
                },

                implementOpen: false,
                implementResult: {},
                implementParams: {
                    id: '',
                    page: 1,
                    pageSize: 10
                }
            }
        },
        created() {
            this.getWordTemplategenerateList()
        },
        methods: {
            getWordTemplategenerateList() {
                let data = this.params
                this.$http.get(url.wordTaskList, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        // this.historyList.list.length > 0 ? this.historyList.list = this.historyList.list.concat(res.data.data.list) : this.historyList = res.data.data
                        this.historyList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            jump(item) {

                if (item.menuId) {
                    this.wordTaskInfo(item)
                    this.ChartOpen = true
                } else {
                    this.getCityList()
                    this.wordTaskInfo(item)
                    this.open = true
                }
            },
            wordTaskInfo(item) {
                let data = {
                    id: item.id
                }
                this.$http.get(url.wordTaskInfo, {params: data}).then(res => {
                    if (res.data.code === '200') {
                        // console.log(res)
                        if (res.data.data) {
                            let response = res.data.data
                            response.city = response.cityPath ? response.cityPath.split(',') : ''
                            this.form = response
                        } else {
                            this.form = {}
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            //   执行记录
            implement(item) {

                this.implementParams.id = item.id
                this.$http.get(url.wordTaskTimeList, {params: this.implementParams}).then(res => {
                    if (res.data.code === '200') {
                        this.implementResult = res.data.data
                        this.implementOpen = true
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            cancel() {
                this.open = false
                this.ChartOpen = false
                this.implementOpen = false
            },
            submitForm() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        let data = JSON.parse(JSON.stringify(this.form))
                        data.cityPath = data.city.join()
                        this.form.city.length > 0 ? data.city = this.form.city[this.form.city.length - 1] : data.city = ''

                        this.$http.post(url.wordTaskupdate, data).then(res => {
                            if (res.data.code === '200') {
                                this.$message.success('修改成功')
                                this.open = false
                                this.getWordTemplategenerateList()
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    }
                });
            },
            ChartSubmitForm() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        if (valid) {
                            let data = this.form

                            this.$http.post(url.wordTaskupdate, data).then(res => {
                                if (res.data.code === '200') {
                                    this.$message.success('修改成功')
                                    this.ChartOpen = false
                                    this.getWordTemplategenerateList()
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })

                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    }
                });
            },
            deleteItem(item, index) {
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    let data = {
                        id: item.id
                    }

                    this.$http.post(url.wordTaskDelete, data).then(res => {
                        if (res.data.code === '200') {
                            this.getWordTemplategenerateList()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }).catch(() => {
                });
            },
            //  查询城市树
            getCityList() {
                let data = {}
                this.$http.get(url.addressAddr, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.cityList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            download(item, type) {
                let data = {
                    id: item.id,
                    type: type,
                    token: localStorage.getItem('token')
                }
                let allUrl = url.wordTemplatedownload + params(data)
                window.open(allUrl, '_blank')
            }
        }
    }
</script>

<style scoped lang="less">

    .HistoryList {

        width: 80%;
        min-width: 550px;
        margin: 0 auto;
        padding: 10px;
        border-left: 1px solid #ddd;
        border-right: 1px solid #ddd;
        background-color: #fff;
        .HistoryItem {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .histyTimer {

            }
            .histyIcon {
                background-color: #1b486f;
                border-radius: 50%;
                margin: 0 20px;

                img {
                    width: 20px;
                    height: 20px;
                }

            }
            .histyName {

                flex: 1;
            }
            .histyOther {

            }
        }
        :last-child {
            margin-bottom: 0;
        }
    }

    .implementList {
        .implementItem {
            border-bottom: 1px solid #ddd;
            /*margin: 8px 0;*/
            padding: 8px 0;
            .implementTime {
                font-weight: bold;
            }
            .implementContent {
                margin: 4px 0;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                /*text-indent: 14px;*/
            }
            .implementResult {
                text-align: right;
            }
        }
        :last-child {
            border-bottom: 0;
        }
    }
</style>